import { render, staticRenderFns } from "./ChefiaValidos.vue?vue&type=template&id=0dd665d1&"
import script from "./ChefiaValidos.vue?vue&type=script&lang=js&"
export * from "./ChefiaValidos.vue?vue&type=script&lang=js&"
import style0 from "./ChefiaValidos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports